module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": _vm.linkHref,
      "target": _vm.linkTarget
    },
    on: {
      "touchend": _vm.$dn.blurActiveElement,
      "mouseup": _vm.$dn.blurActiveElement,
      "click": _vm.onClick
    }
  }, [(_vm.iconLeft) ? _c('dn-icon', {
    staticClass: "dn-btn__icon dn-btn__icon--left",
    attrs: {
      "icon": _vm.iconLeft
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('dn-icon', {
    staticClass: "dn-btn__icon dn-btn__icon--center",
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.iconRight) ? _c('dn-icon', {
    staticClass: "dn-btn__icon dn-btn__icon--right",
    attrs: {
      "icon": _vm.iconRight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasContent) ? _c('div', {
    staticClass: "dn-btn__content"
  }, [_vm._t("content")], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655efce2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/buttons/Btn.vue
// module id = 253
// module chunks = 1